import React from 'react';
import OlMapView from '../olmapview';
import $ from 'jquery';
import {Link} from 'react-router';
import Livingplaces from '../../../models/livingplacecoll';

export default class RouteMapView extends React.Component {
	constructor(props) {
		super(props);
		this.prepRouteGeodata = this.prepRouteGeodata.bind(this);
	}
	componentDidMount() {
	  }
	
	prepRouteGeodata () {
		var infraroutes = this.props.routes
		var pt = this.props.ptquali
		var stort = this.props.xy
		var points = [];
		var lines = [];
		
		for (var key in infraroutes) {
			var r = infraroutes[key];
			if (r.geometry !== null) {
				lines.push({'type': r.type, 'geom': r.geometry});
				points.push({'type': r.type, 'geom': r.targetxy});
			}
		}
		
		if (pt !== null) {
			
			var hst;
			if (pt.nextStation.type === "train_station") {
				hst = "Bahnhaltestelle";
			}
			else {
				hst = "Haltestelle";
			}
			lines.push({'type': hst, 'geom': pt.nextStation.walk_to_station.geometry});
			points.push({'type': hst, 'geom': pt.nextStation.walk_to_station.station_xy});
			if (pt.trainStation !== null && pt.nextStation.type !== "train_station") {
				lines.push({'type': 'Bahnhaltestelle', 'geom': pt.trainStation.walk_to_station.geometry});
				points.push({'type': 'Bahnhaltestelle', 'geom': pt.trainStation.walk_to_station.station_xy});
			}
		}
		
		points.push({'type': 'Standort', 'geom': stort});
		
		return {'points': points, 'lines': lines}
		
	}
	
	  render() {
		  
		    //var lpsdata = {lps: Livingplaces, id: this.props.route.placeid};
		    return (
		    		<OlMapView basemapAtType='grey' id={this.props.id + '_routes'} 
		    		routeGeoData={this.prepRouteGeodata()} mapPurpose = {"displayRoutesToInfrastructure"} styleclass={"routemap"}>
		    		</OlMapView>
		    );
		  }
}


// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/infraresults/routemapview.js